import styled from "styled-components";

export const Button = styled.button`
	background: ${({ theme }) => theme.COLORS.PRIMARY};
	color: ${({ theme }) => theme.COLORS.GRAY_800};
	border: none;
	padding: 16px 24px;
	max-width: 250px;
	min-width: 250px;
	margin: 0px auto;
	font-weight: 900;
	border-radius: 6px;
	transition: all 0.3s ease;
	cursor: pointer;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 4px 8px rgba(0,0,0,0.1);
	}

	&.sort-button {
		max-width: none;
		min-width: auto;
		margin: 0;
		padding: 8px 16px;
		font-weight: 500;
		display: flex;
		align-items: center;
		gap: 8px;
	}
`;

export const StyledWhatsAppButton = styled.a`
	background: ${({ theme }) => theme.COLORS.GREEN};
	color: #fff;
	border: none;
	padding: 16px 24px;
	border-radius: 6px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin: 0 auto;
	cursor: pointer;
	text-decoration: none;
	width: auto;
	min-width: 200px;

	img {
		width: 24px;
		height: 24px;
	}

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 4px 8px rgba(0,0,0,0.1);
	}
`;
